export class ImageCarouselItem {
  constructor(
    public img: string,
    public text: string,
    public textside: 'right' | 'left' | 'center',
    public description?: string,
    public route?: string
  ) {}
}
